import LessonViewer from '../components/LessonViewer';
import { algebra1FreeLessons } from './lessons';

export default function FreeAlgebra1Page() {
  return (
    <LessonViewer
      courseTitle="Algebra 1 — Free Lessons"
      courseSubtitle="Full textbook explanations + Mr. Augustine's exclusive short methods. 20 practice questions per topic with step-by-step solutions."
      gradeLabel="Grade 9 · Algebra 1"
      color="orange"
      topics={algebra1FreeLessons}
      prevLink={{ label: 'Free Lessons Hub', path: '/free-lessons' }}
      nextLink={{ label: 'Geometry Free Lessons', path: '/free-lessons/geometry' }}
    />
  );
}
